// Forked into ../../redesign/Results/GroupTags.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import { useTranslate } from '@bynder/localization';
import type { TagsSearchResults } from '../../types';
import {
	StyledHeadingNoButton,
	StyledHeadingWrapper,
	StyledResultsSection,
	StyledTagsContainer,
} from '../StyledComponents';
import { Tag } from './Tag';

interface Props {
	tags: TagsSearchResults;
}

export function GroupTags({ tags }: Props) {
	const { translate } = useTranslate();

	return (
		<StyledResultsSection $noPaddingBottom>
			<StyledHeadingWrapper>
				<StyledHeadingNoButton>
					<div>{translate('spotlight.dropdown.tags')}</div>
				</StyledHeadingNoButton>
			</StyledHeadingWrapper>
			<StyledTagsContainer>
				{tags.map((tagName, index) => {
					if (index % 2 !== 0) {
						return null;
					}

					const tagQty = tags[index + 1];

					return (
						<Tag tagName={tagName as string} tagQty={tagQty as number} key={tagName} />
					);
				})}
			</StyledTagsContainer>
		</StyledResultsSection>
	);
}
